import React, { FC } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { PrivateRoute } from 'routes/PrivateRoute';
import { PoliciesList } from 'features/Acl/Policies/PoliciesList';
import { PolicyForm } from 'features/Acl/PolicyForm/PolicyForm';
import { UsersGroupList } from 'features/Acl/UsersGroups/UsersGroupsList';
import { UserGroupForm } from 'features/Acl/UserGroupForm/UserGroupForm';
import { AppMenuDrawer } from 'components/AppMenu/AppMenuDrawer';
import { SimpleNavBar } from 'components/NavBar/SimpleNavBar';
import { SwitchCatchNotFound as Switch } from './SwitchCatchNotFound';
import { ManageCompanyRedirects } from './ManageCompanyRedirects';
import { aclPoliciesPrefix, aclUsersGroupsPrefix, policyId, userGroupId, profilePrefix } from './routes';

const AclRoutes: FC<{}> = () => {
  const { t } = useTranslation();
  const { path } = useRouteMatch();

  return (
    <>
      <AppMenuDrawer />
      <ManageCompanyRedirects redirectTo={profilePrefix} />
      <Switch>
        <PrivateRoute
          exact
          path={`${path}${aclPoliciesPrefix}`}
          component={PoliciesList}
          navbar={SimpleNavBar}
          navbarTitle={t('acl.policies list')}
        />
        <PrivateRoute
          exact
          path={`${path}${aclPoliciesPrefix}/new`}
          component={PolicyForm}
          navbar={SimpleNavBar}
          navbarBack
          navbarTitle={t('acl.new policy')}
        />
        <PrivateRoute
          exact
          path={`${path}${aclPoliciesPrefix}${policyId}`}
          component={PolicyForm}
          navbar={SimpleNavBar}
          navbarBack
          navbarTitle={t('acl.policy details')}
        />
        <PrivateRoute
          exact
          path={`${path}${aclUsersGroupsPrefix}`}
          component={UsersGroupList}
          navbar={SimpleNavBar}
          navbarTitle={t('acl.users groups list')}
        />
        <PrivateRoute
          exact
          path={`${path}${aclUsersGroupsPrefix}/new`}
          component={UserGroupForm}
          navbar={SimpleNavBar}
          navbarBack
          navbarTitle={t('acl.user_group.new user group')}
        />
        <PrivateRoute
          exact
          path={`${path}${aclUsersGroupsPrefix}${userGroupId}`}
          component={UserGroupForm}
          navbar={SimpleNavBar}
          navbarBack
          navbarTitle={t('acl.user group details')}
        />
      </Switch>
    </>
  );
};

export { AclRoutes };
